import request from '@/utils/axios.js';

//创建card
export function createCard(data) {
    return request({
        url: '/api/v1/keyConnect/create',
        method: 'post',
        data
    });
}

//查看card
export function getCardById(id) {
    return request({
        url: `/api/v1/keyConnect/getById/${id}`,
        method: 'get'
    });
}

export function keyConnectCreateQRUri(data) {
	return request({
		url: '/api/v1/keyConnect/createQRUri',
		method: 'post',
		data: data
	});
}